import React, { Component } from "react";
import { Spin } from "antd";

import axios from "axios";

export default class Pipeuser extends Component {
  state = {
    loading: true,
    amount: 0,
    field_value: 0
  };

  /** Altera o valor do campo */
  handleChangeAmount = amount => {
    this.setState({
      field_value: amount
    });
  };

  async componentDidMount() {
    /** Obter as pastas do pipedrive */
    const pipedrive_id = this.props.pipedrive_id;

    let index = 0;
    let amount = 0;
    let run = true;

    while (run) {
      await axios
        .get(
          `https://api.pipedrive.com/v1/deals?user_id=${pipedrive_id}&status=open&start=${index}&limit=500&api_token=${this.props.pipedrive_token}`
        )
        .then(response => {
          const data = response.data;
          if (data.data) {
            amount += data.data.length;
            index += 500;
          } else {
            run = false;
          }
        })
        .catch(() => {
          run = false;
        });
    }

    this.setState({
      loading: false,
      amount
    });
  }

  render() {
    let component = null;

    if (this.state.loading) {
      component = (
        <div
          style={{
            margin: "15px",
            textAlign: "center"
          }}
        >
          <Spin />
        </div>
      );
    } else {
      component = (
        <div>
          <div className="imp_user__desc">
            <b>{this.state.amount}</b> pastas no Pipedrive
          </div>
          <input
            type="number"
            onChange={event =>
              this.props.function_change(
                event,
                this.props.pipedrive_id,
                this.handleChangeAmount
              )
            }
            value={this.state.field_value}
            className="ant-input imp__amount"
          />
        </div>
      );
    }

    return (
      <div className="imp_user__grid">
        <div className="imp_user__name">{this.props.username}</div>
        {component}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Importacao/Pipeuser/index.js